import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";
import { toast } from "react-hot-toast";

// Fetch active bundles for user side
export const fetchBundles = createAsyncThunk(
  "bundle/fetchActive",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/bundles");
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Create a new bundle (Admins only)
export const createBundle = createAsyncThunk(
  "bundle/create",
  async (bundleData, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/bundles", bundleData);
      toast.success(res.data.message || "Bundle created successfully");
      return res.data.data;
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Failed to create bundle");
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Toggle bundle status (Admins only)
export const toggleBundleStatus = createAsyncThunk(
  "bundle/toggle",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(`/bundles/${id}/toggle`);
      toast.success(res.data.message || "Status updated successfully");
      return res.data.data;
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Failed to toggle status");
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Delete a bundle (Admins only)
export const deleteBundle = createAsyncThunk(
  "bundle/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.delete(`/bundles/${id}`);
      toast.success(res.data.message || "Bundle deleted successfully");
      return id;
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Failed to delete bundle");
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const bundleSlice = createSlice({
  name: "bundle",
  initialState: {
    bundles: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Bundles
      .addCase(fetchBundles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBundles.fulfilled, (state, action) => {
        state.loading = false;
        state.bundles = action.payload || [];
      })
      .addCase(fetchBundles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch bundles";
      })

      // Create Bundle
      .addCase(createBundle.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBundle.fulfilled, (state, action) => {
        state.loading = false;
        state.bundles.push(action.payload);
      })
      .addCase(createBundle.rejected, (state) => {
        state.loading = false;
      })

      // Toggle Status
      .addCase(toggleBundleStatus.fulfilled, (state, action) => {
        state.bundles = state.bundles.map((b) =>
          b._id === action.payload._id ? action.payload : b
        );
      })

      // Delete Bundle
      .addCase(deleteBundle.fulfilled, (state, action) => {
        state.bundles = state.bundles.filter((b) => b._id !== action.payload);
      });
  },
});

export default bundleSlice.reducer;
